export default {"src":"/_next/static/media/Basketball.bf243add.svg","height":20,"width":20};